import { Component, ElementRef, NgZone, ViewChild, ViewEncapsulation } from '@angular/core';
import type { SwiperContainer } from 'swiper/element';

@Component({
    selector: 'app-partner-testimonial',
    templateUrl: './partner-testimonial.component.html',
    styleUrls: ['./partner-testimonial.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PartnerTestimonialComponent {
  constructor(private readonly ngZone: NgZone) {}

  selectedIndex: number = 0;

  @ViewChild('swiper', { static: false }) swiperElRef?: ElementRef<SwiperContainer>;

  setIndex(index: number) {
    this.selectedIndex = index;
  }

  isSelectedIndex(index: number) {
    return index === this.selectedIndex;
  }

  onSlideChange(event: CustomEvent<[swiper: { activeIndex: number }]>) {
    this.ngZone.run(() => {
      const [swiper] = event.detail;
      this.selectedIndex = swiper ? swiper.activeIndex : 0;
    });
  }

  onButtonClick(index: number) {
    this.ngZone.run(() => {
      this.swiperElRef.nativeElement.swiper.slideTo(index);
    });
  }

  testimonials = [
    {
      name: 'Nadhir Ashafiq',
      title: 'Co-founder, TheLorry',
      imgSrc: 'nadhir-ashafiq.png',
      quotes: [
        '“WatchTower & Friends (WTF) Accelerator has played a pivotal role in launching TheLorry’s business by connecting us to top mentors, industry players and investors.”',
      ],
    },
    {
      name: 'John Ooi',
      title: 'Founder, Material in Works',
      imgSrc: 'john-ooi.png',
      quotes: [
        "“The most significant benefit we've gained from Beyond4's mentorship has been the strategic guidance in securing funding and broadening our network.",
        'This led to us successfully acquiring of the Cradle grant, which provided vital financial support for our sustainability and environmental projects.”',
      ],
    },
  ];
}
